/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Click_Drag_Create_Events_HelpInputs */



/**
* | output |
* | --- |
* | "Create new Events by click-n-dragging on the Timeline." |
*
* @param {Options_Editor_Click_Drag_Create_Events_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_click_drag_create_events_help = /** @type {((inputs?: Options_Editor_Click_Drag_Create_Events_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Click_Drag_Create_Events_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer de nouveaux événements en cliquant-glissant sur la timeline.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Ereignisse erstellen Sie durch Klicken und Ziehen auf der Zeitleiste.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea nuovi eventi cliccando e trascinando sulla sequenza temporale.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создавайте новые события, перетаскивая курсор мыши по временной шкале.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cree nuevos eventos haciendo clic y arrastrando en la línea de tiempo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在时间轴上点击并拖动即可创建新事件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムライン上でクリックしてドラッグして新しいイベントを作成します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमलाइन पर क्लिक करके और ड्रैग करके नए इवेंट बनाएं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Crie novos eventos clicando e arrastando na Linha do Tempo.")
	return /** @type {LocalizedString} */ ("Create new Events by click-n-dragging on the Timeline.")
});